import React, { useEffect, useState } from "react";
import "../../css/ProductCreateScreen.css";
import UploadFileToDatabase from "../../component/UploadFileToDatabase";
import fire from "../../config/fire";
import {
	getDatabase,
	set,
	onValue,
	ref as dbRef,
	push,
} from "firebase/database";
import {
	ref as storageRef,
	getStorage,
	getDownloadURL,
	uploadBytesResumable,
} from "firebase/storage";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoaderComponent from "../../component/LoaderComponent";
import { useAdminAuth } from "../../component/AdminUserPresent";

const ProductCreateScreen = () => {
	const [productTitle, setProductTitle] = useState("");
	const [productDescription, setProductDescription] = useState("");
	const [productCategory, setProductCategory] = useState("");
	const [categories, setCategories] = useState([]);
	const [progress, setProgress] = useState(0);
	const [loader, setLoader] = useState(false);
	const [files, setFiles] = useState([]);
	const storage = getStorage();
	const database = getDatabase();
	const isAdmin = useAdminAuth();

	// 🔹 FETCH CATEGORIES FROM FIREBASE
	useEffect(() => {
		if (!isAdmin) return;
		const categoryRef = dbRef(database, "categories");
		onValue(categoryRef, (snapshot) => {
			const data = snapshot.val();
			if (!data) return;

			const categoryArray = Object.values(data).map((cat) => ({
				id: cat.id,
				title: cat.title,
				path: cat.path,
				slug: cat.path.replace("/categories/", ""), // 👈 important
			}));

			setCategories(categoryArray);

			// set default category
			if (categoryArray.length > 0) {
				setProductCategory(categoryArray[0].slug);
			}
		});
	}, []);

	const handleSubmitDetails = async () => {
		if (!productTitle || !productDescription || files.length === 0) {
			toast.warn("Product title, description and images are required.");
			return;
		}

		const finalFiles = files.map((f) =>
			f.croppedBlob
				? new File([f.croppedBlob], f.file.name, { type: "image/jpeg" })
				: f.file,
		);

		try {
			setLoader(true);
			var n = new Date().toISOString();
			var id =
				n.split(":")[0] + n.split(":")[1] + n.split(":")[2].slice(0, 6);
			let productId = id
				.replace(/-/g, "")
				.replace(".", "")
				.replace("T", "");

			const uploadedFileURLs = [];
			setProgress(0);

			for (let i = 0; i < finalFiles.length; i++) {
				const file = finalFiles[i];
				const fileRef = storageRef(
					storage,
					`productImages/${productId}_${i}`,
				);

				const uploadTask = uploadBytesResumable(fileRef, file);

				await new Promise((resolve, reject) => {
					uploadTask.on(
						"state_changed",
						(snapshot) => {
							const fileProgress =
								(snapshot.bytesTransferred /
									snapshot.totalBytes) *
								100;

							// Overall progress for multiple files
							const overallProgress =
								((i + fileProgress / 100) / finalFiles.length) *
								100;

							setProgress(Math.round(overallProgress));
						},
						(error) => reject(error),
						async () => {
							const downloadURL = await getDownloadURL(
								uploadTask.snapshot.ref,
							);
							uploadedFileURLs.push({
								name: file.name,
								type: file.type.startsWith("image/")
									? "image"
									: "video",
								url: downloadURL,
							});
							resolve();
						},
					);
				});
			}

			const db = getDatabase();
			await set(
				dbRef(db, `productDetails/${productCategory}/${productId}`),
				{
					productTitle,
					productDescription,
					productId,
					productCategory,
					postImageArray: uploadedFileURLs,
					createdDate: Date(),
				},
			);

			toast.success("Details submitted successful...!");
			setFiles([]);
			setProductTitle("");
			setProductDescription("");
			setProgress(0);
			setLoader(false);
		} catch (error) {
			console.error("Upload failed", error);
			toast.error("Upload failed...!, please try again");
			setLoader(false);
		}
	};

	return (
		<div className="container">
			{loader ? <LoaderComponent /> : ""}
			<div className="text-center product-create-screen-header py-4">
				Create Product
			</div>
			<div className="container product-create-layout">
				<div className="row product-create-view d-flex flex-wrap">
					<div className="col-lg-6 col-12 mx-auto my-2">
						<div className="input-field-div">
							<label className="py-1">Product title</label>
							<input
								placeholder="Product title..."
								value={productTitle}
								onChange={(e) =>
									setProductTitle(e.target.value)
								}
								required
							/>
						</div>
					</div>

					<div className="col-lg-6 col-12 mx-auto my-2">
						<div className="input-field-div">
							<label className="py-1">Product Description</label>
							<textarea
								placeholder="Product Description..."
								value={productDescription}
								onChange={(e) =>
									setProductDescription(e.target.value)
								}
								required
							/>
						</div>
					</div>

					{/* 🔹 CATEGORY DROPDOWN */}
					<div className="col-lg-6 col-12 mx-auto my-2">
						<div className="input-field-div">
							<label>Product category</label>
							<select
								className="p-2"
								value={productCategory}
								onChange={(e) =>
									setProductCategory(e.target.value)
								}
								required
							>
								{categories.map((cat) => (
									<option key={cat.id} value={cat.slug}>
										{cat.title}
									</option>
								))}
							</select>
						</div>
					</div>

					<div className="col-lg-6 col-12 mx-auto my-2 pt-3 product-image text-center">
						<UploadFileToDatabase
							files={files}
							setFiles={setFiles}
							progress={progress}
						/>
					</div>
				</div>
				<div className="text-center py-4">
					<button
						className="submit-details"
						onClick={handleSubmitDetails}
					>
						Submit details
					</button>
				</div>
			</div>
		</div>
	);
};

export default ProductCreateScreen;
